import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
  selector: 'kng-checkbox',
  templateUrl: './kng-checkbox.component.html',
  styleUrls: [],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => KngCheckboxComponent),
      multi: true
    }
  ]
})
export class KngCheckboxComponent implements ControlValueAccessor {
  @Input() disabled: boolean = false;
  @Output() kngOnClick: EventEmitter<any> = new EventEmitter();

  public checked: boolean = false;

  constructor() { }

  onClick(){
    this.checked = ! this.checked;

    if( this.kngOnClick ){
      this.kngOnClick.emit();
    }

    this.onChange(this.checked);
  }

  // Function to call when the value changes.
  onChange(value: any) {}

  // Function to call when the input is touched.
  onTouched(){}

  get value(): boolean {
    return this.checked;
  }

  // Allows Angular to update the model.
  // Update the model and changes needed for the view here.
  writeValue(value: any): void {
    this.checked = value;
    this.onChange(this.checked)
  }

  // Allows Angular to register a function to call when the model (rating) changes.
  // Save the function as a property to call later here.
  registerOnChange(fn: (value: any) => void): void {
    this.onChange = fn;
  }

  // Allows Angular to register a function to call when the input has been touched.
  // Save the function as a property to call later here.
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  // Allows Angular to disable the input.
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/layout/kingswell/kng-checkbox/kng-checkbox.component.ts